import {
    DOCUMENT_TYPE,
    GUARD_ARMED_STATUS,
    JOB_STATUSES,
    REPEAT_CYCLE,
    REPEAT_FREQUENCIES,
    SHIFT_STATUSES
} from '../types/enums';
import { GuardListSortOptions } from '../types/jobs';

export const JOB_LIST_SORT_LABEL: {
    [key in GuardListSortOptions]: string;
} = {
    'Distance from near to far': 'Distance',
    'Most relevant': 'Most relevant',
    'Rate from high to low': 'Rate, high to low',
    'Rate from low to high': 'Rate, high to low'
};

export const JOB_LIST_SORT_OPTIONS: {
    label: string;
    value: GuardListSortOptions;
}[] = [
    {
        label: 'Most relevant',
        value: 'Most relevant'
    },
    {
        label: 'Distance from near to far',
        value: 'Distance from near to far'
    },
    {
        label: 'Rate from high to low',
        value: 'Rate from high to low'
    },
    {
        label: 'Rate from low to high',
        value: 'Rate from low to high'
    }
];

export const GENDER_SELECT_OPTIONS = [
    {
        label: 'Male',
        value: 'Male'
    },
    {
        label: 'Female',
        value: 'Female'
    },
    {
        label: 'Other',
        value: 'Other'
    }
];

export const JOB_REPEAT_OPTION_WEEKLY = {
    label: 'Weekly',
    value: REPEAT_CYCLE.WEEKLY
};

export const JOB_REPEAT_OPTION_FORTNIGHTLY = {
    label: 'Fortnightly',
    value: REPEAT_CYCLE.FORTNIGHTLY
};

export const JOB_REPEAT_OPTION_MONTHLY = {
    label: 'Monthly',
    value: REPEAT_CYCLE.MONTHLY
};

export const JOB_REPEAT_OPTION_CUSTOM = {
    label: 'Custom',
    value: REPEAT_CYCLE.CUSTOM
};

export const JOB_REPEAT_OPTIONS_ALL = [
    JOB_REPEAT_OPTION_WEEKLY,
    JOB_REPEAT_OPTION_MONTHLY,
    JOB_REPEAT_OPTION_FORTNIGHTLY,
    JOB_REPEAT_OPTION_CUSTOM
];

export const JOB_REPEAT_CUSTOM_FREQUENCY_OPTION_DAY = {
    label: 'Days',
    value: REPEAT_FREQUENCIES.DAY
};

export const JOB_REPEAT_CUSTOM_FREQUENCY_OPTION_WEEK = {
    label: 'Weeks',
    value: REPEAT_FREQUENCIES.WEEK
};

export const JOB_REPEAT_CUSTOM_FREQUENCY_OPTION_MONTH = {
    label: 'Months',
    value: REPEAT_FREQUENCIES.MONTH
};

export const JOB_REPEAT_CUSTOM_FREQUENCY_OPTIONS_ALL = [
    JOB_REPEAT_CUSTOM_FREQUENCY_OPTION_DAY,
    JOB_REPEAT_CUSTOM_FREQUENCY_OPTION_WEEK,
    JOB_REPEAT_CUSTOM_FREQUENCY_OPTION_MONTH
];

export const GUARD_ARMED_STATUS_OPTIONS = [
    {
        label: 'Armed',
        value: GUARD_ARMED_STATUS.ARMED
    },
    {
        label: 'Unarmed',
        value: GUARD_ARMED_STATUS.UNARMED
    }
];

export type UniformProvidedByOptions = 'Client' | 'Guard';
export type UniformProvidedByLabel = 'Client' | 'Guard';

const UNIFORM_MAPPING = [
    { value: 'Client' as const, label: 'Client' as const },
    { value: 'Guard' as const, label: 'Guard' as const }
] as const;

export const UNIFORM_PROVIDED_BY_OPTIONS: readonly {
    label: UniformProvidedByLabel;
    value: UniformProvidedByOptions;
}[] = UNIFORM_MAPPING;

export const DOCUMENT_TYPE_LABELS: { [key: string]: string } = {
    guard_license: 'Guard License',
    id_card: "Driver's License / State ID",
    carry_permit: 'Carry Permit or RPO',
    first_aid: 'CPR / First Aid Certificate'
};

export const DOCUMENT_TYPE_OPTIONS: { label: string; value: string }[] = [
    {
        label: 'Guard License',
        value: DOCUMENT_TYPE.GUARD_LICENSE
    },
    {
        label: "Driver's License / State ID",
        value: DOCUMENT_TYPE.ID_CARD
    },
    {
        label: 'Carry Permit or RPO',
        value: DOCUMENT_TYPE.CARRY_PERMIT
    },
    {
        label: 'CPR / First Aid Certificate',
        value: DOCUMENT_TYPE.FIRST_AID
    }
];

export const MONTH_OPTIONS = [
    {
        label: 'Jan',
        value: '01'
    },
    {
        label: 'Feb',
        value: '02'
    },
    {
        label: 'Mar',
        value: '03'
    },
    {
        label: 'Apr',
        value: '04'
    },
    {
        label: 'May',
        value: '05'
    },
    {
        label: 'Jun',
        value: '06'
    },
    {
        label: 'Jul',
        value: '07'
    },
    {
        label: 'Aug',
        value: '08'
    },
    {
        label: 'Sep',
        value: '09'
    },
    {
        label: 'Oct',
        value: '10'
    },
    {
        label: 'Nov',
        value: '11'
    },
    {
        label: 'Dec',
        value: '12'
    }
];

export const DAYS_OF_WEEK = [
    {
        label: 'Sunday',
        value: 'sunday'
    },
    {
        label: 'Monday',
        value: 'monday'
    },
    {
        label: 'Tuesday',
        value: 'tuesday'
    },
    {
        label: 'Wednesday',
        value: 'wednesday'
    },
    {
        label: 'Thursday',
        value: 'thursday'
    },
    {
        label: 'Friday',
        value: 'friday'
    },
    {
        label: 'Saturday',
        value: 'saturday'
    }
];

export const SHIFT_STATUS_LABELS = {
    [SHIFT_STATUSES.NOT_APPLIED]: '',
    [SHIFT_STATUSES.ACCEPTED]: 'Confirmed',
    [SHIFT_STATUSES.CANCELLED]: 'Canceled',
    [SHIFT_STATUSES.CALLED_OFF]: 'Called off',
    [SHIFT_STATUSES.REJECTED]: 'Unsuccessful',
    [SHIFT_STATUSES.SHIFT_CANCELLED]: 'Shift cancelled',
    [SHIFT_STATUSES.PENDING]: 'Pending',
    completed: 'Completed' //Completed shifts have the status "accepted" and have passed the shift end datetime
};

export const JOB_STATUS_LABELS = {
    [JOB_STATUSES.ACCEPTED]: 'Pending',
    [JOB_STATUSES.CANCELLED]: 'Canceled',
    [JOB_STATUSES.COMPLETED]: 'Completed',
    [JOB_STATUSES.CONFIRMED]: 'Confirmed',
    [JOB_STATUSES.REJECTED]: 'Rejected',
    [JOB_STATUSES.PENDING]: 'Pending' //Not used in the app
};
